import { render } from "./TarjetaEdicionProducto.vue?vue&type=template&id=2a3b8068&scoped=true"
import script from "./TarjetaEdicionProducto.vue?vue&type=script&lang=js"
export * from "./TarjetaEdicionProducto.vue?vue&type=script&lang=js"

import "./TarjetaEdicionProducto.vue?vue&type=style&index=0&id=2a3b8068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3b8068"]])

export default __exports__